import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get}from 'lodash';
import classNames from 'classnames';

import CheckIndicator from '../CheckIndicator';

type Option = {
	value: string|number;
	label?: string;
}
type RadioGroupProps = {
	name: string;
	options: Option[];
	required?: boolean;
	className?: string;
}
export default (props: RadioGroupProps) => {
	const {name = '', required = false, options = [], className} = props;

	if (!name) {
		console.warn('Missing prop "name" for RadioGroup.');
		return null;
	}

	if (!options.length) {
		console.warn('Missing "options" for RadioGroup.');
		return null;
	}

	const {register, errors, getValues, setValue, watch} = useFormContext();
	const isInvalid = Boolean(get(errors, name));
	const checkedValue = get(getValues({nest: true}), name);

	watch(name);

	return (
		<div className={classNames(
			styles.radiogroup,
			isInvalid && styles.isInvalid,
			!checkedValue && required && styles.isRequired,
			className
		)}>
			<input
				type="hidden"
				name={name}
				ref={register({required})}
			/>
			{
				options.map(({value, label}) => (
					<div
						key={value}
						className={styles.option}
					>
						<label
							onClick={() => setValue(name, value, true)}
							className={styles.label}
						>
							<CheckIndicator
								isChecked={checkedValue === value}
								isInvalid={isInvalid}
								look="circle"
								required={!checkedValue && required}
								className={styles.checkIndicator}
							/>
							{label||value}
						</label>
					</div>
				))
			}
		</div>
	);
}
